import { render, staticRenderFns } from "./BaikalAttractionsIrk.vue?vue&type=template&id=2ce9d22f"
import script from "./BaikalAttractionsIrk.vue?vue&type=script&lang=js"
export * from "./BaikalAttractionsIrk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports